import GenericListModule from "src/core/gd-modules/generic-list/generic-list-module";
import {FIELDS} from "src/core/fields3/fields.const";
import FieldsCollection from "src/core/fields3/collection/base/fields-collection";

export default class TemplatesListModule extends GenericListModule {

    constructor(parentComponent) {
        const fieldsConfig = [
            {fieldId: 'name',           label: 'Title',         type: FIELDS.STRING},
            {fieldId: 'access',         label: 'Access',        type: FIELDS.STRING},
            {fieldId: 'userId',         label: 'Created by',    type: FIELDS.USER},
            {fieldId: 'isDefault',      label: 'Default',       type: FIELDS.CHECKBOX},
        ];

        const fields = new FieldsCollection(fieldsConfig);

        const config = {
            skin: {
                className:                  'ui5-glist skin-modern gl-h-42',
                defaultAlignment:           'left',
            },

            columns: [
                {type: 'field',     fieldId: 'name',                            width: 360},
                {type: 'field',     fieldId: 'access',                          width: 120},
                // {type: 'field',     fieldId: 'userId',                          width: 140},
            ],
            sortBy: {
                fieldId: 'isDefault',
                direction: 'desc'
            },
            // sort by when no sortBy or if items equal by sortBy criteria (always used as second sortBy criteria)
            defaultSortBy: {
                fieldId: 'name',
                direction: 'asc'
            },

            filters: null,
            groupBy: null,

            titleField: 'name',
            headerMode: 'sticky',
            dnd: false,

            noItemsMessage          : 'No templates found',

            // access
            canAddColumns:          false,
            canResizeColumns:       false,
            canSort:                true,
            // canEditItems:           true,
            canChangeColumnsOrder:  false,
            headerMoreButton:       false,
            canDndColumns:          false,
            canDndItems:            false
        }

        super(fields, config);

        this.parentComponent = parentComponent;
    }

    onItemClick(id) {
        this.selection.setSelectedSingle(id);
        this.parentComponent.updateSubmitButton();
    }
}
